module.exports = __webpack_public_path__ + "static/img/pro6.ee2e3a18.png";